<template>
  <div id="app">
    <HeaderMenu></HeaderMenu>
    <router-view/>
    <Footer></Footer>
  </div>
</template>
<script>
import HeaderMenu from '@/components/header.vue'
import Footer from '@/components/footer.vue'
export default {
  components: {
    HeaderMenu,
    Footer
  }
}
</script>
<style>
html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
  cursor: pointer;
}

img {
  display: block
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 设置根元素的默认字体大小 */
html {
  font-size: 16px;
  /* 你可以根据需要调整这个值 */
}

/* 使用媒体查询调整不同屏幕尺寸下的字体大小 */

@media (min-width: 375px) {
  html {
    font-size: 4px;
  }
}

@media (min-width: 390px) {
  html {
    font-size: 5px;
  }
}
@media (min-width: 414px) {
  html {
    font-size: 5px;
  }
}

@media (min-width: 430px) {
  html {
    font-size: 5px;
  }
}
@media (min-width: 576px) {
  html {
    font-size: 8px;
  }
}
@media (min-width: 768px) {
  html {
    font-size: 10px;
  }
}

@media (min-width: 820px) {
  html {
    font-size: 10px;
  }
}

@media (min-width: 992px) {
  html {
    font-size: 12px;
  }
}

@media (min-width: 1024px) {
  html {
    font-size: 12px;
  }
}
@media (min-width: 1280px) {
  html {
    font-size: 14px;
  }
}
@media (min-width: 1440px) {
  html {
    font-size: 16px;
  }
}

@media (min-width: 1600px) {
  html {
    font-size: 16px;
  }
}
</style>
